import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Breadcrumb from '../../components/Breadcrumb';
import DataState from '../../components/DataState';
import { buildProgramPage } from '../../data';
import { useCollections } from '../../lib/api/collections';
import { useSeo } from '../../lib/seo';
import { publicFileUrl } from '../../lib/supabase';

import { programImages } from '../../data/images';

const CourseDetailsMain = () => {
  const { slug } = useParams();
  const content = useCollections('programs');
  const found = content.programs && content.programs.find((p) => p.id === slug);
  // Some degrees have no short summary; build a description from their facts so each page still has its own.
  const autoDescription =
    found &&
    [`${found.title} at SANASA Campus Ltd., Kegalle.`, found.duration && `Duration: ${found.duration}.`, found.language && `Taught in ${found.language}.`, 'See the subjects, entry rules and how to apply.']
      .filter(Boolean)
      .join(' ');
  useSeo(found ? { title: found.seoTitle || `${found.title} | SANASA Campus`, description: found.seoDescription || found.summary || autoDescription } : null);
  if (content.loading || content.error) return <DataState state={content} />;
  const program = content.programs.find((p) => p.id === slug);
  if (!program) return <Navigate to="/programs" replace />;
  const page = buildProgramPage(program);
  const images = programImages(program);
  const { sidebar } = page;

  return (
    <main>
      <Breadcrumb title="Program Details" subTitle="Programs" />

      <div className="it-course-details-area pt-120 pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-9 col-lg-8">
              <Tabs className="it-course-details-wrap" key={slug}>
                <div className="it-evn-details-thumb mb-35">
                  <img src={images.wide} alt="" />
                </div>
                <h4 className="it-evn-details-title mb-0 pb-5">{page.title}</h4>
                <div className="postbox__meta">
                  <span>
                    <i className="fa-light fa-file-invoice"></i>
                    {page.meta[0]}
                  </span>
                  <span>
                    <i className="fa-light fa-clock"></i>
                    {page.meta[1]}
                  </span>
                  <span>
                    <i className="fa-light fa-user"></i>
                    {page.meta[2]}
                  </span>
                </div>

                <div className="it-course-details-nav pb-60">
                  <nav>
                    <TabList
                      className="nav nav-tab"
                      id="nav-tab"
                      role="tablist"
                    >
                      {page.tabs.map((tab) => (
                        <Tab key={tab.label}>
                          <button>{tab.label}</button>
                        </Tab>
                      ))}
                    </TabList>
                  </nav>
                </div>
                <div className="it-course-details-content">
                  <div className="tab-content" id="nav-tabContent">
                    {page.tabs.map((tab) => (
                      <TabPanel key={tab.label}>
                        <div className="it-course-details-wrapper">
                          {tab.blocks.map((block, i) => (
                            <div
                              key={block.h}
                              className={
                                i < tab.blocks.length - 1
                                  ? 'it-evn-details-text mb-40'
                                  : 'it-evn-details-text'
                              }
                            >
                              <h6 className="it-evn-details-title-sm pb-5">
                                {block.h}
                              </h6>
                              {block.paras.map((para) => (
                                <p key={para}>{para}</p>
                              ))}
                            </div>
                          ))}
                        </div>
                      </TabPanel>
                    ))}
                  </div>
                </div>
              </Tabs>
            </div>
            <div className="col-xl-3 col-lg-4">
              <div className="it-evn-sidebar-box it-course-sidebar-box">
                <div className="it-evn-sidebar-thumb mb-30">
                  <img src={images.side} alt="" />
                </div>
                <div className="it-course-sidebar-rate-box pb-20">
                  <div className="it-course-sidebar-rate d-flex justify-content-between align-items-center">
                    <span>{sidebar.label}</span>
                    <span className="rate">{sidebar.price}</span>
                  </div>
                  <i>{sidebar.note}</i>
                </div>
                <Link
                  className="ed-btn-square radius purple-4 w-100 text-center mb-20"
                  to={sidebar.button.to}
                >
                  <span>{sidebar.button.label}</span>
                </Link>
                {program.brochurePath && (
                  <a
                    className="ed-btn-square radius w-100 text-center mb-20"
                    href={publicFileUrl('brochures', program.brochurePath)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span>Download brochure</span>
                  </a>
                )}
                <div className="it-evn-sidebar-list">
                  <ul>
                    {sidebar.labels.map((label, i) => (
                      <li key={label}>
                        <span>{label}</span>
                        <span>{sidebar.values[i]}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default CourseDetailsMain;
